export default "__VITE_ASSET__8d9ab1b8__"